export enum SipErrorsE {
  // Erros conhecidos com base em https://www.inforsolutions.com.br/ticket_sol/knowledgebase.php?article=2
  UNALLOCATED_NUMBER = 1,
  NO_ROUTE_TO_NETWORK = 2,
  NO_ROUTE_TO_DESTINATION = 3,
  CHANNEL_UNACCEPTABLE = 6,
  USER_BUSY = 17,
  NO_USER_RESPONDING = 18,
  NO_ANSWER = 19,
  SUBSCRIBER_ABSENT = 20,
  CALL_REJECTED = 21,
  NUMBER_CHANGED_WITH_DIAGNOSTIC = 22,
  REDIRECTION_TO_NEW_DESTINATION = 23,
  USER_DETERMINED_RELEASE = 26,
  DESTINATION_OUT_OF_ORDER = 27,
  INVALID_NUMBER_FORMAT = 28,
  FACILITY_REJECTED = 29,
  NORMAL_UNSPECIFIED = 31,
  NO_CIRCUIT_AVAILABLE = 34,
  NETWORK_OUT_OF_ORDER = 38,
  TEMPORARY_FAILURE = 41,
  SWITCH_CONGESTION = 42,
  ACCESS_INFORMATION_DISCARDED = 43,
  REQUESTED_CIRCUIT_OR_CHANNEL_NOT_AVAILABLE = 44,
  RESOURCES_UNAVAILABLE = 47,
  INCOMING_CALLS_BARRED_WITHIN_CUG = 55,
  BEARER_CAPABILITY_NOT_AUTHORIZED = 57,
  BEARER_CAPABILITY_UNAVAILABLE = 58,
  BEARER_CAPABILITY_NOT_IMPLEMENTED = 65,
  ONLY_RESTRICTED_DIGITAL_INFO_AVAILABLE = 70,
  SERVICE_OR_OPTION_NOT_IMPLEMENTED = 79,
  INVALID_CALL_REFERENCE_VALUE = 81,
  NOT_MEMBER_OF_CUG = 87,
  INCOMPATIBLE_DESTINATION = 88,
  RECOVERY_ON_TIMER_EXPIRED = 102,
  PROTOCOL_ERROR_UNSPECIFIED = 111,
  INTERWORKING_UNSPECIFIED = 127,

  // Encerramento normal da chamada
  NORMAL_CLEARING = 16,

  // Para casos de erro não mapeados
  CALL_FAILED = 9999,
}
